export default {
  baseUrl: "https://api.hallmarcom.co.il/",
  imgUrl: "https://api.hallmarcom.co.il/",
};
//http://www.api.hallmarcom.co.il/
//http://www.localhost/hallmarcom_prod/
